export default __webpack_public_path__ + "static/media/sso-icon.3582331d.svg";